module.exports = "<ui-form-element *ngIf=\"!!(title || description)\"\n        [title]=\"title\"\n        [boldTitle]=\"boldTitle\"\n        [highlightPhrase]=\"highlightPhrase\"\n        [description]=\"description\">\n</ui-form-element>\n<ng-content></ng-content>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/utils/ui-elements/ui-form-group/ui-form-group.html
// module id = 1100
// module chunks = 3